import { Component, Input, OnInit } from '@angular/core';
import { ChartData } from '../../../models/IChartData';

@Component({
  selector: 'ff-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit {

  /**
   * Data to display use the ChartData interface
   * Format: [{name: string, value: number}]
   * @internal
   */
  @Input() data: any[] = [];

  /**
   * show or hide the x axis
   * Default value: true
   * @internal
   */

  @Input() showXAxis: boolean = true;

  /**
 * show or hide the y axis
 * Default value: true
 * @internal
 */

  @Input() showYAxis: boolean = true;

  /**
* fill elements with a gradient instead of a solid color
* Default value: false
* @internal
*/

  @Input() gradient: boolean = false;

  /**
* show or hide the legend
* Default value: true
* @internal
*/

  @Input() showLegend: boolean = true;

  /**
* show or hide the x axis label
* Default value: true
* @internal
*/

  @Input() showXAxisLabel: boolean = true;

  /**
* the x axis label text
* @internal
*/
  @Input() xAxisLabel: string = '';

  /**
* show or hide the y axis label
* Default value: true
* @internal
*/

  @Input() showYAxisLabel: boolean = true;

  /**
* the y axis label text
* @internal
*/
  @Input() yAxisLabel: string = '';

  /**
* Chart width
* Default value: 700
* @internal
*/
  @Input() width: number = 700;

  /**
* Chart height
* Default value: 400
* @internal
*/
  @Input() height: number = 400;

  /**
* Function to execute in the parent component
* @internal
*/
  @Input() select: Function;

  chartSize: number[] = [];

  colorScheme = {
    domain: []
  };

  constructor() {
  }

  ngOnInit(): void {
    this.chartSize = [this.width, this.height];

    this.data.forEach(() => {
      this.random_hex_color_code();
    });


  }

  onSelect = (event): void => {
    !!this.select
      ? this.select(event)
      : '';
  }

  random_hex_color_code = (): void => {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    this.colorScheme.domain.push('#' + randomColor.slice(0, 6));
  };

}
